var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92077 13.6105C4.76478 13.4677 4.67715 13.2741 4.67715 13.0723C4.67715 12.8704 4.76478 12.6768 4.92077 12.5341L9.32496 8.5048L4.92077 4.47551C4.8413 4.40529 4.77791 4.32129 4.7343 4.22842C4.69069 4.13554 4.66774 4.03565 4.66678 3.93457C4.66582 3.83349 4.68687 3.73325 4.72871 3.6397C4.77055 3.54614 4.83233 3.46115 4.91046 3.38967C4.98858 3.3182 5.08149 3.26167 5.18375 3.2234C5.28601 3.18512 5.39557 3.16586 5.50606 3.16674C5.61654 3.16762 5.72572 3.18862 5.82724 3.22851C5.92876 3.26841 6.02057 3.3264 6.09733 3.39911L11.0898 7.9666C11.2458 8.10935 11.3334 8.30294 11.3334 8.5048C11.3334 8.70666 11.2458 8.90025 11.0898 9.043L6.09733 13.6105C5.94129 13.7532 5.72969 13.8334 5.50905 13.8334C5.28841 13.8334 5.07681 13.7532 4.92077 13.6105Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBold);
export default __webpack_public_path__ + "static/media/arrow-right-bold.2883b0ada208a832e27c3c198cc9388b.svg";
export { ForwardRef as ReactComponent };